export default __webpack_public_path__ + "static/media/TYTAN.f5c962a4.png";